import { badgeProps as f } from "./index600.js";
import { defineComponent as v, computed as s, openBlock as g, createElementBlock as p, normalizeClass as l, unref as n, renderSlot as i, createVNode as b, Transition as h, withCtx as $, withDirectives as y, createElementVNode as x, normalizeStyle as C, createTextVNode as D, toDisplayString as N, vShow as S } from "vue";
import { useNamespace as w } from "./index559.js";
import { isNumber as m } from "./index565.js";
import { addUnit as u } from "./index641.js";
var P = /* @__PURE__ */ v({
  name: "ElBadge",
  __name: "badge",
  props: f,
  setup(t, { expose: d }) {
    const e = t, a = w("badge"), r = s(() => e.isDot ? "" : m(e.value) && m(e.max) ? e.max < e.value ? `${e.max}+` : `${e.value}` : `${e.value}`), c = s(() => {
      var o;
      return [
        {
          backgroundColor: e.color,
          marginRight: u(-e.offset[0]),
          marginTop: u(e.offset[1])
        },
        (o = e.badgeStyle) != null ? o : {}
      ];
    });
    return d({
      /** @description badge content */
      content: r
    }), (o, z) => (g(), p(
      "div",
      {
        class: l(n(a).b())
      },
      [
        i(o.$slots, "default"),
        b(h, {
          name: `${n(a).namespace.value}-zoom-in-center`,
          persisted: ""
        }, {
          default: $(() => [
            y(x(
              "sup",
              {
                class: l([
                  n(a).e("content"),
                  n(a).em("content", t.type),
                  n(a).is("fixed", !!o.$slots.default),
                  n(a).is("dot", t.isDot),
                  n(a).is("hide-zero", !t.showZero && t.value === 0),
                  t.badgeClass
                ]),
                style: C(c.value)
              },
              [
                i(o.$slots, "content", { value: r.value }, () => [
                  D(
                    N(r.value),
                    1
                    /* TEXT */
                  )
                ])
              ],
              6
              /* CLASS, STYLE */
            ), [
              [S, !t.hidden && (r.value || t.isDot || o.$slots.content)]
            ])
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["name"])
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  P as default
};
